<template>
  <div class="wrap d-flex justify-center">
    <!-- <vue-office-docx
      v-if="filetype === 'docx' || filetype === 'doc'"
      :src="filepath"
      style="height: 80vh"
    ></vue-office-docx> -->
    <!-- <vue-office-pdf
      v-if="filetype === 'pdf'"
      :src="filepath"
      style="height: 80vh"
    ></vue-office-pdf> -->
    <!-- <vue-office-excel
      v-if="filetype === 'xlsx' || filetype === 'xls'"
      :src="filepath"
      style="height: 80vh"
    ></vue-office-excel> -->
    <!-- 除了pdf都支持在线预览 -->
    <!-- <iframe
        :src="'https://view.officeapps.live.com/op/view.aspx?src=https://jk.lockhea.com' + filepath"
        frameborder="0"
        width="100%"
        height="800"
      ></iframe> -->
  </div>
</template>

<script>
//import vueOfficeDocx from '@vue-office/docx';
import '@vue-office/docx/lib/index.css';
//import vueOfficeExcel from '@vue-office/excel';
import '@vue-office/excel/lib/index.css';
//import vueOfficePdf from '@vue-office/pdf';

export default {
  props: {
    filepath: {
      // 预览地址
      type: String,
      default: '',
    },
    filetype: {
      // 文件类型
      type: String,
      default: 'xlsx',
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  components: {
    //vueOfficeDocx,
    //vueOfficeExcel,
    //vueOfficePdf,
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
.wrap {
  max-height: 80vh;
  .content {
    white-space: pre;
    width: 100%;
    height: 100%;
    padding: 20px 10px;
    background: #fff;
    overflow-x: auto;
  }
  .van-loading {
    background-color: #fff;
    position: absolute;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
